// Replace with your real assets
// Assuming local public folder access
const LOGOS = {
  MAIN: "/logo.png", 
  SEAL: "https://via.placeholder.com/80?text=Approved"
};

export const generateCertificateHtml = (userName: string, courseTitle: string, groupName: string, dateStr: string) => {
  const origin = window.location.origin;
  const logoSrc = `${origin}${LOGOS.MAIN}`;

  return `
    <html>
      <head>
        <title>Certificate - ${courseTitle}</title>
        <style>
          @page { size: landscape; margin: 0; }
          body { 
            margin: 0; 
            padding: 0; 
            display: flex; 
            justify-content: center; 
            align-items: center; 
            height: 100vh; 
            font-family: 'Times New Roman', serif; 
            background: #f9fafb;
            -webkit-print-color-adjust: exact;
          }
          .certificate-container {
            width: 1000px;
            height: 700px;
            padding: 20px;
            background: #fff;
            position: relative;
            box-shadow: 0 0 20px rgba(0,0,0,0.1);
          }
          .border {
            border: 5px solid #1e40af;
            padding: 5px;
            height: 100%;
            box-sizing: border-box;
          }
          .inner-border {
            border: 2px solid #1e40af;
            height: 100%;
            padding: 30px 50px;
            box-sizing: border-box;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            background: linear-gradient(to bottom right, #fff, #f0fdf4);
            position: relative;
          }
          
          .header {
            position: relative;
            z-index: 1;
            margin-bottom: 10px;
          }
          .title {
            font-size: 52px;
            font-weight: bold;
            color: #1e40af;
            margin: 5px 0;
            text-transform: uppercase;
            letter-spacing: 2px;
          }
          .subtitle {
             font-size: 16px;
             color: #64748b;
             letter-spacing: 4px;
             text-transform: uppercase;
             font-family: sans-serif;
          }
          
          .content {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: relative;
            z-index: 1;
          }
          .presented-to {
            font-size: 16px;
            color: #666;
            margin-bottom: 5px;
            font-style: italic;
            font-family: 'Helvetica', sans-serif;
          }
          .recipient {
            font-size: 42px;
            font-weight: bold;
            color: #0f172a;
            margin: 5px auto 15px auto;
            font-family: 'Helvetica', sans-serif;
            border-bottom: 2px solid #cbd5e1;
            padding-bottom: 5px;
            min-width: 500px;
            display: inline-block;
          }
          .text {
            font-size: 18px;
            line-height: 1.6;
            color: #475569;
            font-family: 'Helvetica', sans-serif;
          }
          .course-name {
            font-size: 28px;
            font-weight: bold;
            color: #1e40af;
            display: block;
            margin: 15px 0;
          }
          
          .footer {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-top: 20px;
            position: relative;
            z-index: 1;
          }
          
          .signature-block {
            text-align: center;
            width: 200px;
          }
          .signature-line {
            border-top: 1px solid #333;
            width: 100%;
            padding-top: 5px;
            font-size: 11px;
            color: #666;
            text-transform: uppercase;
            letter-spacing: 1px;
            font-weight: bold;
            font-family: sans-serif;
          }
          
          .seal {
             width: 100px;
             height: 100px;
             border: 3px double #1e40af;
             border-radius: 50%;
             display: flex;
             flex-direction: column;
             align-items: center;
             justify-content: center;
             color: #1e40af;
             font-weight: bold;
             font-family: sans-serif;
             font-size: 12px;
             text-transform: uppercase;
             letter-spacing: 1px;
             background: #fff;
          }
        </style>
      </head>
      <body>
        <div class="certificate-container">
          <div class="border">
            <div class="inner-border">
              
              <div class="header">
                <img src="${logoSrc}" style="height: 60px; margin-bottom: 20px;" alt="Dads Matter" />
                <h1 class="title">Certificate of Completion</h1>
                <div class="subtitle">Dads Matter Training Hub</div>
              </div>
              
              <div class="content">
                <div class="presented-to">This certifies that</div>
                <div class="recipient">${userName}</div>
                <div class="text">
                  Has successfully completed the module:
                  <span class="course-name">${courseTitle}</span>
                  Registered via: <strong>${groupName}</strong>
                </div>
              </div>

              <div class="footer">
                <div class="signature-block">
                  <div style="font-family: cursive; font-size: 20px; color: #1e40af; margin-bottom: 5px;">Dads Matter</div>
                  <div class="signature-line">Provider</div>
                </div>
                
                <div class="seal">
                    <span>Verified</span>
                    <span style="font-size: 18px;">★</span>
                    <span>Completion</span>
                </div>

                <div class="signature-block">
                  <div style="font-size: 18px; color: #333; margin-bottom: 8px; font-weight: bold;">${dateStr}</div>
                  <div class="signature-line">Date</div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <script>
           window.onload = function() { setTimeout(function(){ window.print(); }, 500); };
        </script>
      </body>
    </html>
  `;
};